module.exports = __webpack_public_path__ + "img/8_26.4614c123.png";